<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Demandas de Consultas - Empresa Contratante"
  description="Gerencie as demandas de consultas da sua empresa">
</cbc-container>

@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">
  <ng-container>
    <div class="content-wrapper">
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let serviceDemand of serviceDemandList; trackBy: trackById; let i = index"
          (opened)="panelOpenState.set(true)"
          (closed)="panelOpenState.set(false)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="mat-panel-title-custom">
                {{ serviceDemand.id }} -
                @if(serviceDemand.professionName) {
                <strong class="field-value">{{ serviceDemand.professionName }}</strong>
                }
                @if(serviceDemand.specialty) {
                - <strong class="field-value">{{ serviceDemand.specialty }}</strong>
                }
              </div>
              <div class="observationText">
                <div>
                  <ng-container *ngIf="serviceDemand.publicationDate; else notPublished">
                    Data da Publicação: {{ serviceDemand.publicationDate | date:'dd/MM/yyyy' }}
                    <span *ngIf="serviceDemand.expirationPublicationDate">
                      - Valido até: {{ serviceDemand.expirationPublicationDate | date:'dd/MM/yyyy' }}
                    </span>
                  </ng-container>
                  <ng-template #notPublished>Não Publicado</ng-template>
                </div>
                <div class="status-badge">
                  {{ serviceDemand.status! | enumDescription }}
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-panel-description class="panel-content">
            <div class="field-row">
              <span>Data da criação:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ serviceDemand.creationDate | date:'dd/MM/yyyy - hh:mm' }}</strong>
            </div>

            <div class="field-row">
              <span>Profissão:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ serviceDemand.professionName }}</strong>
            </div>

            <div class="field-row">
              <span>Especialidade:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ serviceDemand.specialty }}</strong>
            </div>

            <div class="field-row" *ngIf="serviceDemand.activityAreas && serviceDemand.activityAreas.length > 0">
              <span>Áreas de Atuação:</span>
              <span class="field-dots"></span>
              <strong class="field-value">{{ serviceDemand.activityAreas.join(', ') }}</strong>
            </div>

            <div class="field-row">
              <span>Tipos de atendimento:</span>
              <span class="field-dots"></span>
              <strong class="field-value">
                <span *ngIf="serviceDemand.adultCare">Adulto </span>
                <span *ngIf="serviceDemand.pediatricCare">Pediátrico </span>
                <span *ngIf="serviceDemand.serviceFormatOnLine">Online </span>
                <span *ngIf="serviceDemand.serviceFormatPresential">Presencial</span>
              </strong>
            </div>

            <div class="field-row" *ngIf="serviceDemand.address">
              <span>Endereço:</span>
              <span class="field-dots"></span>
              <strong class="field-value">
                {{ serviceDemand.address.street }}, {{ serviceDemand.address.number }} -
                {{ serviceDemand.address.city }}/{{ serviceDemand.address.state }}
              </strong>
            </div>

            <div class="field-row" *ngIf="serviceDemand.amount">
              <span>Valor:</span>
              <span class="field-dots"></span>
              <strong class="field-value">
                {{ serviceDemand.amount | currency:'BRL':'symbol':'1.2-2' }} 
                por {{ serviceDemand.billingUnit! | enumDescription }}
              </strong>
            </div>

            <div *ngIf="serviceDemand.description" class="description-section">
              <strong>Descrição:</strong>
              <p>{{ serviceDemand.description }}</p>
            </div>

            <div class="availability-section">
              <strong>Disponibilidade:</strong>
              <app-availability [availabilityShow]="serviceDemand.availability"></app-availability>
            </div>

            <div *ngIf="serviceDemand.emergencyService && serviceDemand.emergencyServiceAvailability" class="availability-section">
              <strong>Atendimento Plantonista:</strong>
              <app-availability [availabilityShow]="serviceDemand.emergencyServiceAvailability"></app-availability>
            </div>

            <div class="footerButtons">
              <button mat-flat-button *ngIf="!serviceDemand.publicationDate && serviceDemand.id" 
                      (click)="publish(serviceDemand.id.toString())">
                Publicar
                <mat-icon>rocket_launch</mat-icon>
              </button>

              <button mat-button [routerLink]="['serviceDemandForm', serviceDemand.id]">
                Alterar
                <mat-icon>published_with_changes</mat-icon>
              </button>

              <button mat-button *ngIf="serviceDemand.id" 
                      (click)="deleteServiceDemand(serviceDemand.id.toString())">
                Excluir
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-panel-description>
        </mat-expansion-panel>
      </mat-accordion>

      <button mat-flat-button class="btn-primary" [routerLink]="['serviceDemandForm']">
        Criar nova demanda de serviço
        <mat-icon>edit_document</mat-icon>
      </button>
    </div>
  </ng-container>
</div>
}
